import { ProVesselTypes } from '../models/pro.model';

export function getFilenameSafeString(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]/g, '-') // Replace non-alphanumeric characters with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
    .replace(/^-|-$/g, ''); // Remove leading and trailing hyphens
}

/**
 * Builds a safe, consistent filename for GlobeView PRO report downloads.
 * The filename includes the current date, port name, country, UNLOCODE, vessel type, and file extension.
 * All dynamic segments are sanitized to remove spaces and special characters.
 *
 * Example output:
 *   2025-11-11-globeview-pro-report-southampton-uk-unlocode-gbsou-all-vessels.pdf
 *
 * @param portName - The name of the port.
 * @param portCountry - The country of the port.
 * @param unlocode - The UNLOCODE of the port.
 * @param vesselType - The vessel type (uses 'All-Vessels' if NO_VESSEL_TYPE).
 * @param extension - The file extension (e.g., 'pdf', 'eml').
 * @returns A sanitized filename string.
 */
export const buildProReportFileName = (
  portName: string,
  portCountry: string,
  unlocode: string,
  vesselType: ProVesselTypes,
  extension: string
) => {
  const now = new Date();
  const date = now.toISOString().substring(0, 10);

  const resolvedVesselType =
    vesselType === ProVesselTypes.NO_VESSEL_TYPE ? 'All-Vessels' : vesselType;
  const safeResolvedVesselType = getFilenameSafeString(resolvedVesselType);
  const safePortCountry = getFilenameSafeString(portCountry);
  const safePortName = getFilenameSafeString(portName);
  const safeUnlocode = getFilenameSafeString(unlocode);

  return `${date}-globeview-pro-report-${safePortName}-${safePortCountry}-unlocode-${safeUnlocode}-${safeResolvedVesselType}.${extension}`;
};
